var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", { staticClass: "internal-page-banner-main col-12" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "page-title" }, [
            _c("h1", [
              _vm._v(" Benefits \n                        "),
              _vm.role.id <= 1
                ? _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-sm-12 col-md-3 col-lg-2 pull-right"
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          name: "locationType",
                          id: "locationType",
                          label: "text",
                          clearable: false,
                          searchable: false,
                          filterable: false,
                          options: _vm.locationTypeArr,
                          placeholder: "Select Location Type"
                        },
                        model: {
                          value: _vm.locationType,
                          callback: function($$v) {
                            _vm.locationType = $$v
                          },
                          expression: "locationType"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "internal-page-main-section benifit-section-main col-12" },
      [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c("app-slider", {
                key: _vm.sliderType.location_type,
                attrs: { sliderType: _vm.sliderType }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "benifit-section-main col-12 float-l" },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "benifit-section-left col-12 col-sm-4 col-md-4 col-lg-4 float-l"
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "h2",
                            {
                              staticClass:
                                "color-white heading-text-25 line-height-28 bg-color-red pt-15 pb-15 pl-30 pr-30 ucase font-text-bold-mont float-l width-full mb-0"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.locationType.text) +
                                  " Benefits "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bottom-benifit-left bg-color-e1e8ee width-full float-l"
                            },
                            [
                              _vm._l(_vm.benefitList, function(text, index) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "benifit-detail-bt float-l width-full mt-40"
                                    },
                                    [
                                      _c("h4", [
                                        _vm._v(
                                          _vm._s(text.type_name) +
                                            "-" +
                                            _vm._s(text.provider_name)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("p", {
                                        staticClass: "benifit-call-no",
                                        domProps: {
                                          innerHTML: _vm._s(text.phone)
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        { staticClass: "benifit-grup-name" },
                                        [_vm._v(" " + _vm._s(text.group) + " ")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", {
                                        directives: [
                                          {
                                            name: "linkified",
                                            rawName: "v-linkified:options",
                                            value: {
                                              className: "benifit-website"
                                            },
                                            expression:
                                              "{ className: 'benifit-website' }",
                                            arg: "options"
                                          }
                                        ],
                                        domProps: {
                                          innerHTML: _vm._s(text.url)
                                        }
                                      })
                                    ]
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "benifit-section-right col-12 col-sm-8 col-md-8 col-lg-8 float-l"
                      },
                      [
                        _c("img", {
                          staticClass: "benifit-arrow-img",
                          attrs: { src: "/static/images/benifit-arrow.png" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _vm._m(0),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "bottom-right-brnifit-list float-l width-full"
                              },
                              [
                                _c(
                                  "h2",
                                  {
                                    staticClass:
                                      "color-333333 heading-text-25 line-height-28 font-text-semi-medium-mont"
                                  },
                                  [_vm._v(" How to Enroll ")]
                                ),
                                _vm._v(" "),
                                _c("ul", [
                                  _c("li", [
                                    _c(
                                      "p",
                                      { staticClass: "benifit-enroll-no" },
                                      [_vm._v(" 1 ")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "mt-8 color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont float-l colpie-40 pl-20"
                                      },
                                      [
                                        _vm._v(
                                          " Review your coverage options: "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "view-right-benifit-r float-l width-full"
                                      },
                                      [
                                        _vm._l(_vm.sites, function(
                                          text,
                                          index
                                        ) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "view-btn-small-big benifit-btn float-l"
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "hvr-sweep-to-right-blue",
                                                    attrs: {
                                                      href: text.site_url,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "hi-icon icon_1language"
                                                    }),
                                                    _vm._v(" Benefits Website ")
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.benefitGlance, function(
                                          text,
                                          index
                                        ) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "view-btn-small-big benifit-btn float-l"
                                              },
                                              [
                                                text.upload_type == "url"
                                                  ? [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "hvr-sweep-to-right-blue",
                                                          attrs: {
                                                            href: text.doc_path,
                                                            target: "_blank"
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "hi-icon icon_1language"
                                                          }),
                                                          _vm._v(
                                                            "\n                                                                " +
                                                              _vm._s(
                                                                text.button_title
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  : [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "hvr-sweep-to-right-blue",
                                                          attrs: { href: "#" },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.getSignedUrlPath(
                                                                text.doc_path
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "hi-icon icon_1download-arrow"
                                                          }),
                                                          _vm._v(
                                                            "\n                                                                " +
                                                              _vm._s(
                                                                text.button_title
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                              ],
                                              2
                                            )
                                          ]
                                        })
                                      ],
                                      2
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._m(1),
                                  _vm._v(" "),
                                  _vm._m(2)
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "video-section col-12 float-l" },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "row" },
                                    [
                                      _vm.video.length > 0
                                        ? [
                                            _vm._m(3),
                                            _vm._v(" "),
                                            _vm._l(_vm.video, function(
                                              video_data,
                                              index
                                            ) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "pt-20 ca-video-detail col-12 col-sm-4 col-md-4 col-lg-4"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "video-popup"
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href:
                                                                "#" +
                                                                video_data.id +
                                                                "_myModal",
                                                              "data-toggle":
                                                                "modal"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.openModelFunction(
                                                                  video_data.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/video-section-1.jpg",
                                                                alt:
                                                                  "Corresponding benefits"
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "modal fade",
                                                        attrs: {
                                                          id:
                                                            video_data.id +
                                                            "_myModal",
                                                          role: "dialog"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "modal-dialog"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "modal-content"
                                                              },
                                                              [
                                                                _vm._m(4, true),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "modal-body"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "iframe",
                                                                      {
                                                                        attrs: {
                                                                          id:
                                                                            "hrbenifit",
                                                                          width:
                                                                            "466",
                                                                          height:
                                                                            "315",
                                                                          src:
                                                                            video_data.video_url +
                                                                            "?autopause=0",
                                                                          frameborder:
                                                                            "0",
                                                                          allowfullscreen:
                                                                            ""
                                                                        }
                                                                      }
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            })
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.communications, function(
                                  communication,
                                  index
                                ) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        key: "communication" + index,
                                        staticClass:
                                          "bottom-benifit-para width-full float-l communication"
                                      },
                                      [
                                        _c("div", { staticClass: "row" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "ca-video-detail col-12 col-sm-12 col-md-8 col-lg-8"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "video-popup mb-3"
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src:
                                                        communication.banner_url,
                                                      alt:
                                                        "Corresponding benefits"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "ca-video-detail col-12 col-sm-12 col-md-4 col-lg-4"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "view-btn-small-big benifit-btn float-l"
                                                },
                                                [
                                                  communication.is_flyer_doc ==
                                                  1
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  communication.flyer_url !=
                                                                  "",
                                                                expression:
                                                                  "communication.flyer_url !=''"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "hvr-sweep-to-right-blue",
                                                            attrs: {
                                                              href: "#",
                                                              id:
                                                                "flyerid" +
                                                                index
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.getSignedUrlPath(
                                                                  communication.flyer_url
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  communication.flyer_label
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  communication.flyer_url !=
                                                                  "",
                                                                expression:
                                                                  "communication.flyer_url !=''"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "hvr-sweep-to-right-blue",
                                                            attrs: {
                                                              href:
                                                                communication.flyer_url,
                                                              target: "_blank"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  communication.flyer_label
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                  _vm._v(" "),
                                                  communication.is_pamphlet_doc ==
                                                  1
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  communication.pamphlet_url !=
                                                                  "",
                                                                expression:
                                                                  "communication.pamphlet_url !=''"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "hvr-sweep-to-right-blue",
                                                            attrs: {
                                                              href: "#",
                                                              id:
                                                                "pamphletid" +
                                                                index
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.getSignedUrlPath(
                                                                  communication.pamphlet_url
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  communication.pamphlet_label
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  communication.pamphlet_url !=
                                                                  "",
                                                                expression:
                                                                  "communication.pamphlet_url !=''"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "hvr-sweep-to-right-blue",
                                                            attrs: {
                                                              href:
                                                                communication.pamphlet_url,
                                                              target: "_blank"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  communication.pamphlet_label
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                  _vm._v(" "),
                                                  communication.is_ability_doc ==
                                                  1
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  communication.ability_url !=
                                                                  "",
                                                                expression:
                                                                  "communication.ability_url !=''"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "hvr-sweep-to-right-blue",
                                                            attrs: {
                                                              href: "#",
                                                              id:
                                                                "abilityid" +
                                                                index
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.getSignedUrlPath(
                                                                  communication.ability_url
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  communication.ability_label
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  communication.ability_url !=
                                                                  "",
                                                                expression:
                                                                  "communication.ability_url !=''"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "hvr-sweep-to-right-blue",
                                                            attrs: {
                                                              href:
                                                                communication.ability_url,
                                                              target: "_blank"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  communication.ability_label
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                ],
                                                2
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("p", {
                                          directives: [
                                            {
                                              name: "linkified",
                                              rawName: "v-linkified:options",
                                              value: {
                                                className:
                                                  "color-333333 heading-text-14 line-height-20 font-text-semi-medium-mont float-l width-full mt-70"
                                              },
                                              expression:
                                                "{ className: 'color-333333 heading-text-14 line-height-20 font-text-semi-medium-mont float-l width-full mt-70' }",
                                              arg: "options"
                                            }
                                          ],
                                          domProps: {
                                            innerHTML: _vm._s(
                                              communication.description
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        communication.tallfree_no != ""
                                          ? [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "toll-free-call color-333333 heading-text-20 line-height-24 font-text-semi-medium-mont mt-45 float-l width-full"
                                                },
                                                [
                                                  _vm._v(" Call "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "color-red font-text-bold-mont"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.mobilenumber(
                                                              _vm.mobilenumber(
                                                                communication.tallfree_no,
                                                                3,
                                                                "-"
                                                              ),
                                                              7,
                                                              "-"
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "mb-3 color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont float-l width-full mt-1"
                                                },
                                                [
                                                  _vm._v(
                                                    " Toll Free 24/7 access to EAP. "
                                                  )
                                                ]
                                              )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ]
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.supports, function(support, index) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "bottom-benifit-para width-full float-l"
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ca-video-detail col-12 col-sm-12 col-md-8 col-lg-8"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "video-popup mb-3" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: support.banner_url,
                                                  alt: "Corresponding benefits"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ca-video-detail col-12 col-sm-12 col-md-4 col-lg-4"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "view-btn-small-big benifit-btn float-l"
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        support.flyer_url != "",
                                                      expression:
                                                        "support.flyer_url !=''"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "hvr-sweep-to-right-blue",
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.getSignedUrlPath(
                                                        support.flyer_url
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        support.flyer_label
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        support.pamphlet_url !=
                                                        "",
                                                      expression:
                                                        "support.pamphlet_url !=''"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "hvr-sweep-to-right-blue",
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.getSignedUrlPath(
                                                        support.pamphlet_url
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        support.pamphlet_label
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("p", {
                                      directives: [
                                        {
                                          name: "linkified",
                                          rawName: "v-linkified:options",
                                          value: {
                                            className:
                                              "color-333333 heading-text-14 line-height-20 font-text-semi-medium-mont float-l width-full mt-70"
                                          },
                                          expression:
                                            "{ className: 'color-333333 heading-text-14 line-height-20 font-text-semi-medium-mont float-l width-full mt-70' }",
                                          arg: "options"
                                        }
                                      ],
                                      domProps: {
                                        innerHTML: _vm._s(support.description)
                                      }
                                    }),
                                    _vm._v(" "),
                                    support.tallfree_no != ""
                                      ? [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "toll-free-call color-333333 heading-text-20 line-height-24 font-text-semi-medium-mont mt-45 float-l width-full"
                                            },
                                            [
                                              _vm._v(" Call "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "color-red font-text-bold-mont"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.mobilenumber(
                                                          _vm.mobilenumber(
                                                            support.tallfree_no,
                                                            3,
                                                            "-"
                                                          ),
                                                          7,
                                                          "-"
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "mb-3 color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont float-l width-full mt-1"
                                            },
                                            [
                                              _vm._v(
                                                " Toll Free 24/7 access to EAP. "
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ]
                            })
                          ],
                          2
                        )
                      ]
                    )
                  ])
                ]
              )
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      {
        staticClass:
          "benifit-sec-para color-333333 heading-text-16 line-height-22 float-l width-full font-text-semi-medium-mont border-bottom-dddddd pb-55"
      },
      [
        _vm._v(" The Company provides comprehensive "),
        _c("span", { staticClass: "font-text-bold-mont" }, [
          _vm._v(" medical, dental and vision plans ")
        ]),
        _vm._v(
          " for eligible employees and their dependents on the first day of the month following 30 days of employment. Eligible\n                                    employees are employees working 30 hours or more per week. "
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("p", { staticClass: "benifit-enroll-no" }, [_vm._v(" 2 ")]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass:
            "color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont pl-22 pt-10 colpie-92 float-l"
        },
        [
          _vm._v(
            " Have dates of birth and Social Security numbers for any dependents you plan to enroll "
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("p", { staticClass: "benifit-enroll-no" }, [_vm._v(" 3 ")]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass:
            "color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont float-l colpie-45 pl-20"
        },
        [
          _vm._v(
            " Log onto the dayforce website and go to the benefits section to make your enrollment elections. "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "view-btn-small-big benifit-btn-v float-r colpie-55" },
        [
          _c(
            "a",
            {
              staticClass: "hvr-sweep-to-right-blue float-r",
              attrs: {
                href: "https://www.dayforcehcm.com/mydayforce/login.aspx",
                target: "_blank"
              }
            },
            [_vm._v(" Log onto the Dayforce Website ")]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "float-l width-full" }, [
      _c("li", [
        _c(
          "p",
          {
            staticClass:
              "color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont pl-16 colpie-92 float-l width-full"
          },
          [
            _vm._v(
              " To Learn More About The Benefits We Offer, Please Watch Video Below"
            )
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "modal-title" }, [
        _vm._v("Corresponding benefits")
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: { type: "button", "data-dismiss": "modal" }
        },
        [_vm._v("×")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-312f40ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-312f40ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Benefits.vue
// module id = null
// module chunks = 